import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Modal from '@mui/material/Modal';
import ReactDOM from 'react-dom';
import BillPrint from '../sale/Bill';

const StockJournalEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const handleInputChange = (newValue) => newValue;
    const handleItemChange = (newValue) => newValue;
    const [selectedBank, setSelectedBank] = useState("");
    const [dropdownBankOptions, setDropdownBankOptions] = useState([]);
    const branchId = 0;
    const [remarks, setRemarks] = useState("");


    const formatDateForInput = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const [BillDate, setBillDate] = React.useState(formatDateForInput(today));

    const [data, setData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const fetchTableData = async () => {

        setData([]);
        try {
            const response = await fetchData('StockJournalApi', `/${id}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data.StockJournal);
                setInvoicedeatils(response.response_data.StockJournalDetails)
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }

    };

    const fetchItemOptions = async (inputValue) => {
        // Early return if input value length is less than or equal to 2
        if (inputValue.length <= 2) {
            return [];
        }

        try {
            // Fetch data from the API
            const response = await fetchData('StockJournalApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: `${item.ItemName} (${item.QuantityStock})`,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    // Handle customer selection


    const fetchmaxbillno = (invtype) => {
        fetchData('StockJournalApi', `/MaxBillno/${companyId}/${branchId}/${invtype}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillPrefix: data.BillPrefix,
                    FinYear: data.FinYear,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            const quantity = parseFloat(modalData.Quantity) || 0;;
            const rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            const cgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const sgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const cessrate = parseFloat(selectedItemDetail.CESSRate.toFixed(2)) || 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            const amount = (quantity * (rate / (1 + gstrate / 100))).toFixed(2);
            let Discper = 0;
            let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
            let totdiscount = parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let cessamt = 0;

            if (formData.InvoiceTypeId == 3) {
                igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((taxableamount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((taxableamount * (sgstrate)) / 100).toFixed(2);
            }
            cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(taxableamount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt) + parseAndFix(cessamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                CESSRate: cessrate,
                CESSAmount: cessamt,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountPercentage: Discper,
                DiscountAmount: totdiscount * quantity,
                TaxableAmount: taxableamount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                QuantityStock: selectedItemDetail.QuantityStock,
                PacketStock: selectedItemDetail.PacketStock,
                Noofpktinacase: selectedItemDetail.Noofpktinacase,
                HSNCode: selectedItemDetail.HSNCode,
                QuantityInPackets: 0,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: '0.00',
                DiscountPercentage: '0.00',
                DiscountAmount: '0.00',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                QuantityStock: '',
                PacketStock: 0,
                Noofpktinacase: 0,
                HSNCode: '',
                QuantityInPackets: 0,
            });
        }
    };

    useEffect(() => {
        fetchmaxbillno(0);
    }, []);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    // const [formData, setFormData] = useState([]);
    const [formData, setFormData] = useState({
        PaidAmount: 0,
        BalanceAmount: 0,
    });


    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = 0;
        let qty = parseAndFix(item.Quantity);
        let quantityInPackets = parseAndFix(item.QuantityInPackets);
        quantity = quantityInPackets > 0 ? quantityInPackets : qty;

        let cgstrate = parseAndFix(item.GSTRate / 2);
        let sgstrate = parseAndFix(item.GSTRate / 2);
        let cessrate = parseAndFix(item.CESSRate);
        let gstrate = (cgstrate + sgstrate).toFixed(2);
        let amount = (quantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        let cgstamt = 0;
        let sgstamt = 0;
        let igstamt = 0;


        if (formData.InvoiceTypeId == 3) {
            igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
        } else {
            cgstamt = ((taxableamount * cgstrate) / 100).toFixed(2);
            sgstamt = ((taxableamount * sgstrate) / 100).toFixed(2);
        }
        let cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
        let gstamt = (parseAndFix(cgstamt) + parseAndFix(sgstamt) + parseAndFix(igstamt)).toFixed(2);
        let totalAmount = (parseAndFix(taxableamount) + parseAndFix(cgstamt) + parseAndFix(sgstamt) + parseAndFix(igstamt) + parseAndFix(cessamt)).toFixed(2);

        return {
            ...item,
            CESSRate: cessrate,
            CESSAmount: cessamt,
            Amount: amount,
            TaxableAmount: taxableamount,
            CGSTAmount: parseAndFix(cgstamt).toFixed(2),
            SGSTAmount: parseAndFix(sgstamt).toFixed(2),
            IGSTAmount: parseAndFix(igstamt).toFixed(2),
            TotalAmount: parseAndFix(totalAmount).toFixed(2),
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
        };
    };



    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                acc.CESSAmount += parseAndFix(item.CESSAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Update the input field immediately
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        // setFormData((prevData) => ({
        //     ...prevData,
        //     [name]: updatedValue,
        // }));

        setData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));


    };




    useEffect(() => {
        // This effect runs when formData is updated and specific fields need to be recalculated
        if (formData.CashDiscount || formData.CashAmount || formData.CardAmount || formData.UPIAmount) {
            const updateDetails = () => {
                const updatedItemData = invoicedeatils.map((item) => calculateItemData(item, formData));
                setInvoicedeatils(updatedItemData);

                const totals = updatedItemData.reduce(
                    (acc, item) => {
                        acc.Quantity += parseAndFix(item.Quantity);
                        acc.Amount += parseAndFix(item.Amount);
                        acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                        acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                        acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                        acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                        acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                        acc.TotalAmount += parseAndFix(item.TotalAmount);
                        acc.CESSAmount += parseAndFix(item.CESSAmount);
                        return acc;
                    },
                    { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
                );

                const DiscountAmount = parseAndFix(formData.DiscountAmount);
                const CashAmount = parseAndFix(formData.CashAmount);
                const CardAmount = parseAndFix(formData.CardAmount);
                const UPIAmount = parseAndFix(formData.UPIAmount);
                let PaidAmount = parseAndFix(formData.PaidAmount);
                let Freight = parseFloat(formData.Freight) || 0;
                let PackingCharge = parseFloat(formData.PackingCharge) || 0;

                totalCalculation(
                    totals.Quantity,
                    totals.Amount,
                    totals.CGSTAmount,
                    totals.SGSTAmount,
                    totals.IGSTAmount,
                    totals.TotalAmount,
                    CashAmount,
                    totals.DiscountAmount,
                    CardAmount,
                    UPIAmount,
                    totals.TaxableAmount,
                    totals.CESSAmount,
                    PaidAmount,

                    Freight,
                    PackingCharge
                );
            };

            updateDetails();
        }
    }, [formData.CashDiscount, formData.CashAmount, formData.CardAmount, formData.UPIAmount]);




    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            const updatedItemData = updatedRecords.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.CESSAmount += parseAndFix(item.CESSAmount);
                    return acc;
                },
                { Quantity: 0, Amount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
            );


            const DiscountAmount = parseAndFix(formData.DiscountAmount);
            const CashAmount = parseAndFix(formData.CashAmount);
            const CardAmount = parseAndFix(formData.CardAmount);
            const UPIAmount = parseAndFix(formData.UPIAmount);
            let PaidAmount = parseAndFix(formData.PaidAmount);

            let Freight = parseFloat(formData.Freight) || 0;
            let PackingCharge = parseFloat(formData.PackingCharge) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                CashAmount,
                DiscountAmount,
                CardAmount,
                UPIAmount,
                totals.CESSAmount,
                PaidAmount,

                Freight,
                PackingCharge
            );

        }

    };

    //Items    
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        QuantityInPackets: '0',
        Rate: '',
        Amount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            QuantityInPackets: '0',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                QuantityInPackets: '0',
                Rate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const CESSAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CESSAmount), 0);



            let CashAmount = parseFloat(formData.CashAmount) || 0;
            let CardAmount = parseFloat(formData.CardAmount) || 0;
            let UPIAmount = parseFloat(formData.UPIAmount) || 0;
            let PaidAmount = parseAndFix(formData.PaidAmount);

            let Freight = parseFloat(formData.Freight) || 0;
            let PackingCharge = parseFloat(formData.PackingCharge) || 0;

            totalCalculation(Quantity, Amount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, CashAmount, DiscountAmount, CardAmount, UPIAmount, TaxableAmount, CESSAmount, PaidAmount, Freight, PackingCharge);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };

    const totalCalculation = (Quantity, Amount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, CashAmount, DiscountAmount, CardAmount, UPIAmount, TaxableAmount, CESSAmount, PaidAmount, Freight, PackingCharge) => {

        let netAmt = TaxableAmount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount) + parseFloat(CESSAmount) + parseFloat(Freight) + parseFloat(PackingCharge);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);

        let balhamt = parseFloat(totalAmt - (PaidAmount)).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: parseFloat(DiscountAmount).toFixed(2),
            TaxableAmount: parseFloat(TaxableAmount).toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            CESSAmount: CESSAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: totalAmt,
            BalanceAmount: balhamt,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const [customerdetails, setCustomerDetails] = useState([]);

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        if (name === 'Quantity') {

            const quantity = parseFloat(value) || 0;
            const rate = modalData.Rate;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            let cessrate = parseAndFix(modalData.CESSRate);
            const amount = (quantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);

            let Discper = parseFloat(modalData.DiscountPercentage) || 0;
            let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
            let totdiscount = parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);

            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((taxableamount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((taxableamount * (sgstrate)) / 100).toFixed(2);
            }
            let cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(taxableamount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt) + parseAndFix(cessamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate, // Assuming Rate is a number           
                Quantity: quantity,
                QuantityInPackets: 0,
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                CESSRate: cessrate,
                CESSAmount: cessamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                DiscountPercentage: Discper,
                DiscountAmount: totdiscount * quantity,
                TaxableAmount: taxableamount,
            });
        }
        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            let cessrate = parseAndFix(modalData.CESSRate);
            const amount = (quantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);

            let Discper = parseFloat(modalData.DiscountPercentage) || 0;
            let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
            let totdiscount = parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);

            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((taxableamount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((taxableamount * (sgstrate)) / 100).toFixed(2);
            }
            let cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(taxableamount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt) + parseAndFix(cessamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate.toFixed(2), // Assuming Rate is a number                         
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                CESSRate: cessrate,
                CESSAmount: cessamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                DiscountPercentage: Discper,
                DiscountAmount: totdiscount * quantity,
                TaxableAmount: taxableamount,
                QuantityInPackets: 0,
            });

        }

    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        setInvoicedeatils((prevDetails) => {
            const newDetails = [...prevDetails];
            newDetails[index] = {
                ...newDetails[index],
                [name]: value,
            };

            const updatedItemData = newDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.CESSAmount += parseAndFix(item.CESSAmount);
                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
            );

            const DiscountAmount = parseAndFix(formData.DiscountAmount);
            const CashAmount = parseAndFix(formData.CashAmount);
            const CardAmount = parseAndFix(formData.CardAmount);
            const UPIAmount = parseAndFix(formData.UPIAmount);
            const PaidAmount = parseAndFix(formData.PaidAmount);
            let Freight = parseFloat(formData.Freight) || 0;
            let PackingCharge = parseFloat(formData.PackingCharge) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                CashAmount,
                totals.DiscountAmount,
                CardAmount,
                UPIAmount,
                totals.TaxableAmount,
                totals.CESSAmount,
                PaidAmount,

                Freight,
                PackingCharge
            );

            return updatedItemData;
        });
    };

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownBankOptions();
    }, []);

    const fetchDropdownSalesManOptions = () => {
        fetchData('StockJournalApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownBankOptions = () => {
        fetchData('StockJournalApi', `/Bank/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownBankOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Bank dropdown options:', error);
            });
    };

    const handleBranchChange = (e, index) => {
        const newInvoiceDetails = [...invoicedeatils];
        newInvoiceDetails[index].StockFromBranchId = e.target.value;
        setInvoicedeatils(newInvoiceDetails);
    };

    const checkStockLevels = (item) => {
        if (item.StockFromBranchId === "1") {
            return item.Quantity > item.PBVRStock;
        } else if (item.StockFromBranchId === "2") {
            return item.Quantity > item.CHERIStock;
        }
    };

    const handleUpdatedDataSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        const StockMaster = {
            Id: id,
            BranchId: branchId,
            CompanyId: companyId,
            Remarks: data.Remarks,
            BillDate: data.BillDate,
            BillNumber: data.BillNumber,
            CreatedBy: data.CreatedBy,
            CreateData : data.CreateData,
            FinYear: data.FinYear,
            IsActive : data.IsActive,
            UpdatedBy : userId
        }

        const CreateData = {
            StockJournal: StockMaster,
            StockJournalDetails: invoicedeatils
        };

        // Validate form data here if needed

        updateData('StockJournalApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/StockJournalIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex" style={{ marginTop: '-10px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>STOCK JOURNAL EDIT </h6>
                    <Button
                        // variant="contained"
                        //style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                        style={{
                            background: 'linear-gradient(to right, #16423C,#16423C)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'whitesmoke',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '-5px'
                        }}
                        onClick={handleUpdatedDataSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "UPDATE"}
                    </Button>

                    <Button

                        component={Link}
                        to="/StockJournalIndex"
                        className="linkcolor"
                        //style={{ marginLeft: '8px' }}
                        style={{
                            background: 'linear-gradient(to right, #821131,#821131)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'whitesmoke',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '-5px'
                        }}
                    >
                        CANCEL
                    </Button>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: '#CDE8E5', maxHeight: '500px', overflowY: 'auto', width: '100%' }}>

                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(data.BillDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='BillDate'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={`${data.BillPrefix || ''}${data.BillNumber || ''}/${data.FinYear || ''}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BILL NUMBER"
                                    name='BillNumber'
                                    readOnly
                                />
                            </div>
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={data.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Remarks"
                                    name='Remarks'

                                />
                            </div>
                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#163020' }}>
                                                <th style={{ padding: '4px', backgroundColor: '#163020', color: 'whitesmoke' }}>Item Name</th>
                                                <th style={{ padding: '4px', backgroundColor: '#163020', textAlign: 'center', fontSize: '14px', color: 'whitesmoke' }}>Qty</th>
                                                <th style={{ padding: '4px', backgroundColor: '#163020', textAlign: 'right', fontSize: '14px', color: 'whitesmoke' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => {
                                                const isStockExceeded = checkStockLevels(invdetail);
                                                return (
                                                    <tr key={index} style={{ width: '100%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                        <td style={{ padding: '4px', fontSize: '14px', width: '35%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <label style={{ marginTop: '9px', color: 'black' }}>
                                                                {`${invdetail.ItemName}`}
                                                            </label>
                                                        </td>
                                                        <td style={{ padding: '4px', fontSize: '14px', width: '6%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="number"
                                                                value={invdetail.Quantity}
                                                                onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                                                style={{ textAlign: 'right' }}
                                                                name="Quantity"
                                                            />
                                                        </td>

                                                        <td style={{ padding: '2px', marginTop: '-15px', width: '5%', textAlign: 'right', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <IconButton style={{ padding: '8px', color: 'red' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                    </table>
                                </TableContainer>

                            </div>
                        </div>


                    </div>

                    <div className="w-full mb-4 flex" style={{ marginLeft: '10px', width: '50%', marginTop: '10px' }}>
                        <div className="w-full pr-4">
                            <div className="rounded-lg shadow-lg p-6" style={{ backgroundColor: '#CDE8E5' }}>
                                {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                                <p style={{ color: '#643843' }}>SELECT ITEMS FROM HERE .....</p>
                                <div className="w-full mb-2 flex">
                                    <div className="w-full mr-3">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                            Item Name
                                        </label>

                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={fetchItemOptions}
                                            onInputChange={handleItemChange}
                                            onChange={handleChangeDrop}
                                            value={selectedItemOption}
                                        />
                                    </div>
                                    <div className="w-1/4 mr-2">
                                        <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData} style={{ marginLeft: '6px', marginTop: '25px' }}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <div className="w-full mb-2 flex">

                                    {/* <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                            Quantity
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="Quantity"
                                            placeholder="Quantity"
                                            value={modalData.Quantity}
                                            onChange={handleModalInputChange}
                                        />
                                    </div> */}



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >

    );
};

export default StockJournalEdit;